import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgIf } from "@angular/common";
import { ClrCommonFormsModule, ClrIconModule } from "@clr/angular";
import { ClarityIcons, exclamationCircleIcon, floppyIcon } from "@cds/core/icon";
import { Delivery, WebserviceResponse } from "../../../../_shared/interfaces";
import { AlertService, DeliveryStoreService, IAlertType } from "../../../../_shared/services";

@Component({
  selector: 'app-delivery-details-edit-position',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ClrCommonFormsModule,
    ClrIconModule,
    NgIf
  ],
  templateUrl: './delivery-details-edit-position.component.html',
  styleUrl: './delivery-details-edit-position.component.sass'
})
export class DeliveryDetailsEditPositionComponent implements OnInit {
  public editDeliveryForm: FormGroup = new FormGroup({});
  positions: Delivery[] = [];

  @Input() projectId: string = '';
  @Input() deliveryId: number = 0;
  @Input() jobId: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter<boolean>();

  constructor(
    private delss: DeliveryStoreService,
    private fb: FormBuilder,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon);
  }

  ngOnInit(): void {
    this.loadDeliveryPosition();
  }

  private initForm(): void {
    if (!this.positions.length || Object.keys(this.editDeliveryForm.controls).length > 0) return;
    const p = this.positions[0];
    this.editDeliveryForm = this.fb.group({
      project_id: [this.projectId],
      delivery_id: [this.deliveryId],
      job_id: [this.jobId],
      position: [this.editPosition],
      part: [this.editPart],
      name: [p.name ?? ''],
      technical_drawing: [p.technical_drawing ?? ''],
      material: [p.material ?? ''],
      description: [p.description ?? ''],
      remarks: [p.remarks ?? ''],
      side_agreements: [p.side_agreements ?? ''],
      serial_nr: [p.serial_nr ?? ''],
      heat_nr: [p.heat_nr ?? ''],
      controlling_nr: [p.controlling_nr ?? ''],
      number_of_pieces: [p.number_of_pieces ?? 0],
      selling_price: [p.selling_price ?? 0],
      technology: [p.technology ?? false],
      taric: [p.taric ?? '0'],
      comment_phm: [p.comment_phm ?? ''],
      specification: [p.specification ?? ''],
    });
  }

  private loadDeliveryPosition(): void {
    this.delss.getDeliveryPositions(
      this.projectId,
      this.jobId,
      this.deliveryId,
      String(this.editPosition),
      String(this.editPart)
    ).subscribe({
      next: data => {
        if (!data || data.hasErrors || !Array.isArray(data.object) || data.object.length === 0) {
          this.alertDispatcher.show({
            message: 'Lieferschein-Position konnte nicht geladen werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.positions = data.object;
        this.initForm();
      }
    });
  }

  updateDeliveryPosition(): void {
    if (!this.editDeliveryForm.valid) return;
    this.delss.updateDeliveriesPosition(this.editDeliveryForm.value).subscribe({
      next: (data: WebserviceResponse<Delivery>) => {
        if (!data || data.hasErrors) {
          this.alertDispatcher.show({
            message: 'Lieferschein-Position konnte nicht geändert werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.alertDispatcher.show({
          message: 'Lieferschein-Position wurde gespeichert.',
          clrAlertType: IAlertType.SUCCESS
        }, 3000);
        this.updatedPosition.emit(true);
      }
    });
  }

}
